module.exports = __webpack_public_path__ + "static/img/029.dc08c8fd.png";